export const PERSONAL_ROOT_ID = 'personal'
export const TEAM_ROOT_ID = 'team'
export const SAMPLE_ROOT_ID = 'sample'

export const rootFolderIdOf = space => {
  if (space === 1) return TEAM_ROOT_ID
  if (space === 0) return PERSONAL_ROOT_ID
  return null
}

export const isSpaceRootFolderId = id => [PERSONAL_ROOT_ID, TEAM_ROOT_ID].includes(String(id))

export const spaceOfRootFolderId = id => {
  if (String(id) === TEAM_ROOT_ID) return 1
  if (String(id) === PERSONAL_ROOT_ID) return 0
  return null
}

export const apiParentIdOf = id => (isSpaceRootFolderId(id) ? 0 : id)

export const normalizeFolders = (list, space = null, depth = 1) =>
  (list || []).map(item => ({
    ...item,
    space: item.space ?? space,
    depth: item.depth ?? depth,
    folderName: item.folderName,
    children: normalizeFolders(item.children || [], item.space ?? space, (item.depth ?? depth) + 1),
    childrenLoaded: !!item.childrenLoaded || Array.isArray(item.children),
    hasSubFolder: !!item.hasSubFolder || !!(item.children && item.children.length)
  }))

export const cloneFolderTree = list =>
  (list || []).map(item => ({
    ...item,
    hasSubFolder: !!item.hasSubFolder || !!(item.children && item.children.length),
    children: cloneFolderTree(item.children || [])
  }))

export const findFolderById = (items, folderId) => {
  for (const item of items || []) {
    if (String(item.id) === String(folderId)) return item
    const child = findFolderById(item.children, folderId)
    if (child) return child
  }
  return null
}

export const findFolderParent = (items, folderId, parent = null) => {
  for (const item of items || []) {
    if (String(item.id) === String(folderId)) return parent
    const found = findFolderParent(item.children, folderId, item)
    if (found) return found
  }
  return null
}

export const collectFolderIds = (node, ids = []) => {
  if (!node) return ids
  ids.push(node.id)
  ;(node.children || []).forEach(child => collectFolderIds(child, ids))
  return ids
}

export const createRootFolder = (space, children = [], labels = {}) => ({
  id: rootFolderIdOf(space),
  space,
  folderName: space === 1 ? labels.team : labels.personal,
  children,
  childrenLoaded: true,
  hasSubFolder: children.length > 0,
  isRoot: true
})

export const parseUrlFolderState = search => {
  const params = new URLSearchParams(search)
  let folderId = params.get('folderId')
  const space = params.get('space')
  const parsedSpace = space === '0' || space === '1' ? Number(space) : null
  if (folderId === '0' && parsedSpace === 0) folderId = PERSONAL_ROOT_ID
  else if (folderId === '1' && parsedSpace === 1) folderId = TEAM_ROOT_ID
  return {
    folderId,
    space: parsedSpace,
    isSample: folderId === SAMPLE_ROOT_ID
  }
}

export const resolveRequestFolderState = ({
  currentFolderId,
  currentFolderSpace,
  urlFolderId,
  urlSpace,
  options = {}
}) => {
  let parentId = currentFolderId
  let space = currentFolderSpace
  const lastUrlFolderId = urlFolderId?.split(',').slice(-1)[0]

  if (lastUrlFolderId) parentId = lastUrlFolderId
  if (options?.parentId !== undefined && options?.parentId !== null) parentId = options.parentId

  if (parentId === SAMPLE_ROOT_ID) {
    space = null
  } else {
    const rootSpace = spaceOfRootFolderId(parentId)
    if (options?.space !== undefined) {
      space = options.space
    } else if (rootSpace !== null) {
      space = rootSpace
    } else if (urlSpace !== null) {
      space = urlSpace
    }
  }

  return {
    displayFolderId: parentId,
    parentId: apiParentIdOf(parentId),
    space
  }
}
